import "./footer.css";
import frontgirl from "../img/frontgirl.png";
import ohdeer from "../img/ohdeer.jpg";

export default function Footer() {
  return (
    <div className="venadito-container">
        
      <img src={frontgirl} id="girl" style={{ zIndex: 2 }} />
      <img src={ohdeer} id="venadito"  />
      <img src={ohdeer} id="venadito2"  />
    </div>
  );
}
